import React, { useState } from "react";
import validator from "validator";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import { BASE_URL, INDIAN_STATES } from "../constants";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { FILE_RULES, validateFile } from "../utils/fileValidation";

const INITIAL_STATE = {
  orgName: "",
  orgEmail: "",
  orgPassword: "",
  orgConfirmPassword: "",
  orgOwnerName: "",
  orgOwnerContact: "",
  orgAddress1: "",
  orgAddress2: "",
  orgPhone: "",
  orgState: null,
  orgLogo: null,
  orgCert: null,
};
const OrgReg = () => {
  const navigate = useNavigate();
  const [orgData, setOrgData] = useState(INITIAL_STATE);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  // const handleChange = (e) => {
  //   setOrgData({
  //     ...orgData,
  //     [e.target.name]: e.target.value,
  //   });
  // };
  const handleChange = (e) => {
    setOrgData({
      ...orgData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle file upload change
  const handleLogoChange = async (e) => {
    const file = e.target.files[0];
    const result = await validateFile(file, FILE_RULES.image);
    if (!result.valid) {
      alert(result.error);
      e.target.value = "";
      return;
    }
    setOrgData({
      ...orgData,
      orgLogo: file,
    });
  };

  const handleCertChange = async (e) => {
    const file = e.target.files[0];
    const result = await validateFile(file, FILE_RULES.image);
    if (!result.valid) {
      alert(result.error);
      e.target.value = "";
      return;
    }
    setOrgData({
      ...orgData,
      orgCert: file,
    });
  };

  const handlePasswordToggle = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate orgName
    if (!orgData.orgName) {
      newErrors.orgName = "Organization name is required.";
    }

    if (!orgData.orgOwnerName) {
      newErrors.orgOwnerName = "Owner name is required.";
    }

    // Validate orgEmail
    if (!orgData.orgEmail || !validator.isEmail(orgData.orgEmail)) {
      newErrors.orgEmail = "A valid email is required.";
    }

    // Validate orgPassword
    if (orgData.orgPassword.length < 8 || !/\d/.test(orgData.orgPassword)) {
      newErrors.orgPassword =
        "Password must be at least 8 characters long and contain at least one number.";
    }

    // Validate orgOwnerContact (Indian format)
    if (!/^[6-9]\d{9}$/.test(orgData.orgOwnerContact)) {
      newErrors.orgOwnerContact = "Invalid 10-digit contact number.";
    }

    if (!orgData.orgAddress1) {
      newErrors.orgAddress1 = "Org address line 1 is required.";
    }
    if (!orgData.orgAddress2) {
      newErrors.orgAddress2 = "Org address line 2 is required.";
    }
    if (!orgData.orgPhone) {
      newErrors.orgPhone = "Org phone no. is required.";
    }

    // Validate orgOwnerPanCardNo
    // if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(orgData.orgOwnerPanCardNo)) {
    //   newErrors.orgOwnerPanCardNo = "Invalid PAN card number format.";
    // }

    if (orgData.orgPassword !== orgData.orgConfirmPassword) {
      console.log("DDDFDFF");
      newErrors.orgConfirmPassword = "Password do not match";
    }
    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const formData = new FormData();
      for (const key in orgData) {
        if (key === "orgState") {
          // If it's orgState, stringify it
          formData.append(key, JSON.stringify(orgData[key]));
        } else {
          formData.append(key, orgData[key]);
        }
      }
      try {
        const response = await axios.post(
          `${BASE_URL}api/org/register`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        console.log("Registration response:", response.data);
        const data = response.data;
        if (data?.success) {
          navigate("/org-verify-otp", {
            state: {
              orgEmail: data.orgEmail || orgData.orgEmail,
              orgId: data.orgId || "",
              orgName: orgData.orgName || "",
              message:
                data.message ||
                `Registration successful! Verification OTP sent to ${data.orgEmail || orgData.orgEmail}.`,
            },
          });
        } else {
          alert(data?.message || "Registration failed. Please try again.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert(
          error.response?.data?.message ||
            "Error submitting form. Please check your details and try again.",
        );
      } finally {
        setLoading(false);
      }
    }
  };

  // try {
  //   const response = await fetch(`${BASE_URL}api/org/register`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(orgData),
  //   });

  //   const data = await response.json();

  //   if (data.success) {
  //     console.log("Registration successful", data);
  //     alert(data.message);
  //     setOrgData(INITIAL_STATE);
  //   } else {
  //     console.log("Error:", data.message);
  //     alert("Error: " + data.message);
  //   }
  // } catch (error) {
  //   console.error("Error:", error);
  //   alert("Something went wrong! Please try again.");
  // } finally {
  //   setLoading(false);
  // }
  return (
    <Box
      sx={{
        maxWidth: 500,
        mx: "auto",
        mt: 5,
        p: 3,
        boxShadow: 3,
        borderRadius: 2,
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="h5" align="center" gutterBottom>
        Organization Registration
      </Typography>
      <form onSubmit={handleSubmit} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Organization Name"
              name="orgName"
              value={orgData.orgName}
              onChange={handleChange}
              fullWidth
              margin="normal"
              error={!!errors.orgName}
              helperText={errors.orgName}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Email"
              name="orgEmail"
              type="email"
              value={orgData.orgEmail}
              onChange={handleChange}
              fullWidth
              margin="normal"
              error={!!errors.orgEmail}
              helperText={errors.orgEmail}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Owner Name"
              name="orgOwnerName"
              value={orgData.orgOwnerName}
              onChange={handleChange}
              fullWidth
              margin="normal"
              error={!!errors.orgOwnerName}
              helperText={errors.orgOwnerName}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Owner Contact"
              name="orgOwnerContact"
              type="number"
              value={orgData.orgOwnerContact}
              onChange={handleChange}
              fullWidth
              margin="normal"
              error={!!errors.orgOwnerContact}
              helperText={errors.orgOwnerContact}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <TextField
              label="Org Address line 1"
              name="orgAddress1"
              type="text"
              value={orgData.orgAddress1}
              onChange={handleChange}
              fullWidth
              margin="normal"
              error={!!errors.orgAddress1}
              helperText={errors.orgAddress1}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <TextField
              label="Org Address line 2"
              name="orgAddress2"
              type="text"
              value={orgData.orgAddress2}
              onChange={handleChange}
              fullWidth
              margin="normal"
              error={!!errors.orgAddress2}
              helperText={errors.orgAddress2}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Org Phone Number"
              name="orgPhone"
              type="number"
              value={orgData.orgPhone}
              onChange={handleChange}
              fullWidth
              margin="normal"
              error={!!errors.orgPhone}
              helperText={errors.orgPhone}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel id="org-state-label">Org State</InputLabel>
              <Select
                labelId="org-state-label"
                id="org-state"
                name="orgState"
                value={orgData.orgState ? orgData.orgState.code : ""}
                onChange={(e) => {
                  const selectedState = INDIAN_STATES.find(
                    (state) => state.code === e.target.value,
                  );
                  setOrgData((prevState) => ({
                    ...prevState,
                    orgState: selectedState
                      ? { state: selectedState.name, code: selectedState.code }
                      : null,
                  }));
                }}
              >
                {INDIAN_STATES.map((state) => (
                  <MenuItem key={state.code} value={state.code}>
                    {state.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Typography>Choose Logo</Typography>
            <TextField
              type="file"
              fullWidth
              margin="normal"
              variant="outlined"
              name="orgLogo"
              inputProps={{ accept: "image/*" }} // Accept only images
              onChange={handleLogoChange}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <Typography>Choose Certificate</Typography>
            <TextField
              type="file"
              fullWidth
              margin="normal"
              variant="outlined"
              name="orgLogo"
              inputProps={{ accept: "image/*" }} // Accept only images
              onChange={handleCertChange}
            />
          </Grid>
          {console.log(orgData)}
          <Grid item xs={12} lg={6}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextField
                label="Password"
                name="orgPassword"
                type={showPassword ? "text" : "password"}
                value={orgData.orgPassword}
                onChange={handleChange}
                fullWidth
                margin="normal"
                error={!!errors.orgPassword}
                helperText={errors.orgPassword}
              />
              <IconButton
                sx={{ width: "50px", height: "50px" }}
                onClick={handlePasswordToggle}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </div>
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Confirm Password"
              name="orgConfirmPassword"
              type="password"
              value={orgData.orgConfirmPassword}
              onChange={handleChange}
              fullWidth
              margin="normal"
              error={!!errors.orgConfirmPassword}
              helperText={errors.orgConfirmPassword}
            />
          </Grid>
        </Grid>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          disabled={loading}
          sx={{ mt: 2, py: 1.2, fontWeight: 700 }}
          onClick={handleSubmit}
        >
          {loading ? "Registering..." : "Register"}
        </Button>

        <Box
          sx={{
            mt: 2.5,
            pt: 2,
            borderTop: "1px solid #E2E8F0",
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Button
            component={Link}
            to="/org-login"
            sx={{
              textTransform: "none",
              fontSize: "0.85rem",
              color: "#2563EB",
            }}
          >
            Already have an account? Sign In
          </Button>

          <Button
            component={Link}
            to="/org-verify-otp"
            sx={{
              textTransform: "none",
              fontSize: "0.85rem",
              color: "#64748B",
            }}
          >
            Verify Email OTP &rarr;
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default OrgReg;
